import { memo, useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { Select } from 'antd';
import { useSearchContext } from '../Context';
import { useQuery } from '@tanstack/react-query';
import { querySpuLabel } from '@knowledge/service/api/spu';
import { get, map } from 'lodash-es';

export const LabelSelect = memo(() => {
  const { t } = useTranslate();
  const { tagId, setParams } = useSearchContext();
  const [searchValue, setSearchValue] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['getTag', searchValue],
    queryFn: ({ queryKey }) => {
      const [, searchValue] = queryKey;
      return querySpuLabel({ tagName: searchValue, pageInfo: { pageSize: 99999, pageNo: 1 } });
    },
  });
  const options = useMemo(() => {
    return map(get(data, 'list', []), (item) => ({
      label: item.name,
      value: String(item.id),
    }));
  }, [data]);

  return (
    <Select
      showSearch
      loading={isLoading}
      allowClear
      mode="multiple"
      maxTagCount="responsive"
      maxTagTextLength={5}
      maxTagPlaceholder={(omittedValues) => {
        return t('knowledge.item.etc', { x: omittedValues.length });
      }}
      placeholder={t('knowledge.item.select.search.label')}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={(value) => {
        setSearchValue(value);
      }}
      onChange={(value) => {
        setParams({ tagId: value });
      }}
      value={tagId}
      options={options}
      className="w-[170px]"
    />
  );
});

LabelSelect.displayName = 'ItemSelectV5LabelSelect';
